module.exports = __webpack_public_path__ + "774756476a8cd536e1c2095dcb23a58b.svg";